import React, { useState, useEffect } from "react";
import "./App.css";


import AppRoutes from "routes/AppRoutes";

import { ThemeProvider } from "contexts/ThemeContext";
import { UserProvider } from "contexts/UserContext";
import { MainStateProvider } from "contexts/MainStateContext";
import { PermisosProvider } from "contexts/PermisosContext";

function App() {
  
  return (
    <UserProvider>
      <ThemeProvider>
        <MainStateProvider>
          <PermisosProvider permisos={[]}>
            <AppRoutes />
          </PermisosProvider>
        </MainStateProvider>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;